import { render, staticRenderFns } from "./Responder.vue?vue&type=template&id=eddcd740&lang=pug&"
import script from "./Responder.vue?vue&type=script&lang=js&"
export * from "./Responder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports